import React, { useState } from "react"
import { useDispatch } from "react-redux"

import ResetPassword from "@/components/AccountSettings/v1/ResetPassword"
import Modal from "@/components/core/Modal/Modal"

import { addAnalyticsForEditBtn } from "@/components/AccountSettings/v1/LoginSecurity/analytics"

import loginSecurityStyle from "@/components/AccountSettings/v1/LoginSecurity/index.module.scss"
import { showToast } from "@/store/features/genericSlice"
const LoginSecurity = ({ i18n = {}, data = {}, ...props }) => {
  const dispatch = useDispatch()
  const [showModal, setShowModal] = useState(false)

  const openModal = () => {
    setShowModal(true)
  }
  const closeModal = () => {
    setShowModal(false)
  }

  const handleEditBtnClick = () => {
    openModal()
    addAnalyticsForEditBtn()
  }

  return (
    <React.Fragment>
      <Modal
        showModal={showModal}
        onModalClose={closeModal}
        modalTitle={i18n?.managePassword}
      >
        <div className={`account-settings__modal`}>
          <h2 className="account-settings__modal-title">
            {i18n?.managePassword}
          </h2>
          <ResetPassword
            showModal={showModal}
            i18n={i18n}
            onSuccess={() => {
              closeModal()
              dispatch(
                showToast({
                  message: i18n?.passwordChanged,
                  isVisible: true,
                })
              )
            }}
          />
        </div>
      </Modal>
      <div className={`${loginSecurityStyle?.loginSecurityStyleWrapper}`}>
        <div className="login-security">
          <div className="account-settings__section-header">
            <div
              className="account-settings__section-title"
              role="heading"
              aria-level="2"
            >
              {i18n?.loginSecurity}
            </div>
            <div className="login-security__edit">
              <div
                role="button"
                aria-label={i18n?.editLogin}
                tabIndex="0"
                onClick={() => handleEditBtnClick()}
              >
                {i18n?.edit}
              </div>
            </div>
          </div>
          <div className="login-security__content">
            <div className="login-security__email">
              <div className="login-security__key">{i18n?.email}</div>
              <div className="login-security__value">{data?.email}</div>
            </div>
            <div className="login-security__password">
              <div className="login-security__key">{i18n?.password}</div>
              <div className="login-security__value">............</div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default LoginSecurity
